<template>
  <div>
    <el-dialog
     :title="title"
    :append-to-body="true"
    :before-close="closeView"
    :close-on-click-modal="false"
     class="addTaskView"
      :visible="currentStep === 1"
      width="550px">
      <!-- <span slot="title" class="dialog-footer">
        <span>{{title}}</span>
      </span> -->
      <el-form ref="ruleForm"  :rules="rules" :model="form">
        <el-row>
           <span class="star">*</span> 任务名称
          </el-row>
        <el-form-item label="" prop="taskName">
          <el-input maxlength="30" :disabled="operate === 'detail'" v-model.trim="form.taskName" placeholder="请输入任务名称" size="small"></el-input>
        </el-form-item>

        <el-row>
            任务描述
        </el-row>
        <el-form-item label="" prop="taskDesc">
           <el-input maxlength="40"  :disabled="operate === 'detail'" type="textarea" v-model="form.taskDesc" placeholder="请输入任务描述" size="small"></el-input>
        </el-form-item>
      </el-form>

      <el-form v-if="operate === 'update'" ref="ruleForm2"  :rules="rules" :model="form2">
        <el-row>
           <span class="star">*</span> 生效日期
          </el-row>
        <el-form-item label="" prop="date">
          <el-date-picker
          style="width:100%"
            v-model="form2.date"
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="operate === 'update'"  type="primary" @click="update" size="small">确认修改</el-button>
         <el-button v-else-if="operate === 'detail'"  type="primary" @click="more" size="small">更多详情</el-button>
        <el-button  v-else type="primary" @click="addTask" size="small">下一步</el-button>
        <el-button @click="closeView" size="small">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/assets/js/eventBus'
import { editTask } from '@/api/dataStatistics'
import { dateFormat } from '@/assets/js/tools'
export default {
  components: {
  },
  props: {
    currentStep: {
      type: Number
    },
    operate: {
      type: String
    },
    taskDetail: {
      type: Object || null
    }
  },
  data: function () {
    return {
      form: {
        taskName: this.taskDetail ? this.taskDetail.taskName : '',
        taskDesc: this.taskDetail ? this.taskDetail.taskDesc : ''
      },
      form2: {
        date: [
          this.taskDetail.beginTime ? this.taskDetail.beginTime : '',
          this.taskDetail.endTime ? this.taskDetail.endTime : ''
        ]
      },
      rules: {
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请输入日期', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    title () {
      if (this.operate === 'update') {
        return '修改任务'
      } else if (this.operate === 'detail') {
        return '查看详情'
      } else {
        return '新建任务'
      }
    }
  },
  watch: {
    taskDetail () {
      if (this.taskDetail) { // 查看详情时候重新赋值显示
        Object.assign(this.form, {
          taskName: this.taskDetail ? this.taskDetail.taskName : '',
          taskDesc: this.taskDetail ? this.taskDetail.taskDesc : ''
        })
        Object.assign(this.form2.date, [
          this.taskDetail.beginTime ? this.taskDetail.beginTime : '',
          this.taskDetail.endTime ? this.taskDetail.endTime : ''
        ])
      }
    }
  },
  created () {
    eventBus.$on('resetFields', this.resetFields)
  },
  methods: {
    resetFields () {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    closeView () {
      this.$refs.ruleForm.resetFields()
      this.$emit('closeView')
    },
    nextStep () {
      Object.assign(this.taskDetail, this.form)
      this.$emit('nextStep', 2)
    },
    more () {
      this.$emit('nextStep', 2)
    },
    update () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$refs.ruleForm2.validate((valid) => {
            if (valid) {
              const params = {
                params: Object.assign({
                  taskId: this.taskDetail.taskId,
                  beginTime: dateFormat(this.form2.date[0]),
                  endTime: dateFormat(this.form2.date[1])
                }, this.form)
              }
              editTask(params).then(res => {
                res = res.data
                if (res.code === 200) {
                  this.$message({
                    message: '任务修改成功',
                    type: 'success'
                  })
                  this.$emit('update')
                  this.closeView()// 关闭弹窗
                } else {
                  this.$message.error('任务修改失败')
                }
              })
            }
          })
        }
      })
    },
    addTask () {
      this.$refs.ruleForm.validate((valid) => {
        // 复制的页面的旧逻辑
        if (valid) {
          // 打开第二步骤
          this.nextStep()
        }
      })
    }
  }
}
</script>
<style lang="less" scope>
.addTaskView{
  .star{
       color:#d93026;
    }
    .el-row{
      margin-bottom: 10px;
    }
  }
</style>
